<app-resume-parsing-state [initialParsingState]="model.resumeParsingStatus" (parsingCompleted)="onParsingCompleted($event)"></app-resume-parsing-state>
<form #employmentHistoryForm="ngForm" novalidate>
  <div class="row">
    <div class="col-12">
      <div class="box">
        <h2>Employment History</h2>
        <div class="formBody pt-2">
          <div [innerHTML]="model.configuration.instructionsToApplicants"></div>
          <app-experience *ngFor="let experience of model.experience; let index = index" (remove)="removeExperience(experience, index)"
                          [index]="index" [experience]="experience" [configuration]="model.configuration"></app-experience>
          <div class="row no-gutters">
            <div class="col-12 text-center">
              <a href="javascript:void(01);" class="btn btn-outline" (click)="addExperience()">Add Period of Employment</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12">

    </div>
  </div>
  <div class="row mt-2">
    <div class="col-12 text-right">
      <button class="btn-default btn" mdbWavesEffect (click)="displayCancelModal()">Cancel</button>
      <button class="btn-outline btn" mdbWavesEffect *ngIf="canNavigateBackwards" (click)="back()">Previous</button>
      <button class="btn btn-primary mr-0" mdbWavesEffect [disabled]="!employmentHistoryForm.form.valid || processingServerSideRequest" (click)="save()">
        <i class="fa fa-spinner fa-spin" aria-hidden="true" *ngIf="processingServerSideRequest"></i> Save and Continue</button>
    </div>
  </div>
  <div class="row mt-3">
    <div class="col-12 text-right">
      <a (click)="openSaveAndFinishLater()" [disabled]="processingServerSideRequest" *ngIf="saveAndFinishLaterEnabled" class="saveAndFinishLaterLink">
        Save and Finish Later
      </a>
    </div>
  </div>
</form>

<div mdbModal #cancelModal="mdbModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myBasicModalLabel"
     aria-hidden="true">
  <div class="modal-dialog" role="document">
    <form (ngSubmit)="cancel()" novalidate>
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close pull-right" aria-label="Close" (click)="cancelModal.hide()">
            <span aria-hidden="true">×</span>
          </button>
          <h4 class="modal-title w-100" id="myModalLabel">Cancel Job Application</h4>
        </div>
        <div class="modal-body">
          By canceling, you will lose all data and you'll return to the open jobs page. Are you sure you want to cancel?
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-default" aria-label="Close" (click)="cancelModal.hide()" mdbWavesEffect>No</button>
          <button type="submit" class="btn btn-primary" mdbWavesEffect>Yes</button>
        </div>
      </div>
    </form>
  </div>
</div>

<app-save-and-finish-later [open]="openSaveAndFinishLaterModal" [jobId]="jobId" (saved)="saveAndFinishLater($event)" (closed)="closeSaveAndFinishLater()"></app-save-and-finish-later>
